import React, { useEffect, useState } from "react";
import { getProgress } from "../Apis/endpoints";

function ProgressBar({ videoId }) {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let interval;

    const fetchProgress = async () => {
      try {
        const data = await getProgress(videoId);
        const newProgress = parseInt(data.percentage, 10);

        // Only update progress if the new value is greater than or equal to the current value
        setProgress((prevProgress) =>
          newProgress >= prevProgress ? newProgress : prevProgress
        );

        if (newProgress >= 100) {
          clearInterval(interval); // Stop polling at 100%
        }
      } catch (err) {
        console.error("Error fetching progress:", err);
      }
    };

    // Fetch immediately and then poll every 250ms
    fetchProgress();
    interval = setInterval(fetchProgress, 250);

    return () => clearInterval(interval);
  }, [videoId]);

  // Dynamic colors based on progress percentage
  const getProgressColor = () => {
    return "bg-[#2563EB]"; // Custom Tailwind color
  };

  return (
    <div className="flex flex-col items-center justify-center min-w-[70%] p-5">
      <div className="w-full max-w-lg bg-gray-300 rounded-full overflow-hidden shadow-lg">
        <div
          className={`h-6 ${getProgressColor()} transition-all ease-in-out duration-700`}
          style={{
            width: `${progress}%`,
            backgroundSize: "20px 20px",
            backgroundImage:
              "linear-gradient(45deg, rgba(255,255,255,0.3) 25%, transparent 25%, transparent 50%, rgba(255,255,255,0.3) 50%, rgba(255,255,255,0.3) 75%, transparent 75%, transparent)",
          }}
        ></div>
      </div>

      <p className="text-lg font-medium mt-3">{progress}%</p>
    </div>
  );
}

export default ProgressBar;
